import { render, staticRenderFns } from "./trust-badges.vue?vue&type=template&id=794fdaa9&scoped=true&"
import script from "./trust-badges.vue?vue&type=script&lang=js&"
export * from "./trust-badges.vue?vue&type=script&lang=js&"
import style0 from "./trust-badges.vue?vue&type=style&index=0&id=794fdaa9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794fdaa9",
  null
  
)

export default component.exports